import { formatDateForFilter } from "../../../features/dataFormatFunctions/dataFormatter";
import { getItemWebStorage } from "../../../features/webStorageSaver";
import { tableEnums } from "../../table/tableFeatures/tableEnums";

export function prepareQueryArgsForTableFetch(lazyState: any, columns: any) {
    let sortField = lazyState?.sortField, page = lazyState?.page ?? 0, sortOrder = lazyState?.sortOrder;
    let filters: any = lazyState?.filters
    const filterStringArray: any = []
    for (const filter in filters) {
        const col = columns.filter((col: any) => col.field === filter)[0]
        if (filters[filter].value != null && filters[filter].value != '') {
            if (filters[filter].matchMode === 'startsWith') {
                filterStringArray.push(`startsWith(${filter}, '${filters[filter].value}')`)
            }
            if (filters[filter].matchMode === 'contains') {
                filterStringArray.push(`position('${filters[filter].value}', ${filter}) gt 0`)
            }
            if (filters[filter].matchMode === 'equals' && tableEnums[filter]) {
                filterStringArray.push(`${filter} eq ${tableEnums[filter][filters[filter].value]}`)
            }
            if (filters[filter].matchMode === 'equals' && !tableEnums[filter]) {
                if (col.valueType === 'date') {
                    filterStringArray.push(`${filter} eq ${formatDateForFilter(filters[filter].value?.replace(/\\./g, '-'))}`)
                } else {
                    let filterValue: any = parseFloat(parseFloat(filters[filter].value?.replace(',', '.'))?.toFixed(4))
                    const lowEdge = filterValue - 0.0005
                    const highEdge = filterValue + 0.0005
                    filterStringArray.push(`${filter} ge ${lowEdge} and ${filter} le ${highEdge}`)
                }
            }
            if (filters[filter].matchMode === 'gt' && !tableEnums[filter]) {
                let filterValue: any
                if (col.valueType === 'date') {
                    filterValue = formatDateForFilter(filters[filter].value?.replace(/\\./g, '-'))
                } else {
                    filterValue = parseFloat(parseFloat(filters[filter].value?.replace(',', '.'))?.toFixed(4)) + 0.0005
                }
                filterStringArray.push(`${filter} gt ${filterValue}`)
            }
            if (filters[filter].matchMode === 'gte' && !tableEnums[filter]) {
                let filterValue: any
                if (col.valueType === 'date') {
                    filterValue = formatDateForFilter(filters[filter].value?.replace(/\\./g, '-'))
                    filterStringArray.push(`${filter} ge ${filterValue}`)
                } else {
                    filterValue = parseFloat(parseFloat(filters[filter].value?.replace(',', '.'))?.toFixed(4)) - 0.0005
                    filterStringArray.push(`${filter} gt ${filterValue}`)
                }
            }
            if (filters[filter].matchMode === 'lt' && !tableEnums[filter]) {
                let filterValue: any
                if (col.valueType === 'date') {
                    filterValue = formatDateForFilter(filters[filter].value?.replace(/\\./g, '-'))
                } else {
                    filterValue = parseFloat(parseFloat(filters[filter].value?.replace(',', '.'))?.toFixed(4)) - 0.0005
                }
                filterStringArray.push(`${filter} lt ${filterValue}`)
            }
            if (filters[filter].matchMode === 'lte' && !tableEnums[filter]) {
                let filterValue: any
                if (col.valueType === 'date') {
                    filterValue = formatDateForFilter(filters[filter].value?.replace(/\\./g, '-'))
                    filterStringArray.push(`${filter} le ${filterValue}`)
                } else {
                    filterValue = parseFloat(parseFloat(filters[filter].value?.replace(',', '.'))?.toFixed(4)) + 0.0005
                    filterStringArray.push(`${filter} lt ${filterValue}`)
                }
            }
            if (filters[filter].matchMode === 'notEquals' && !tableEnums[filter]) {
                if (col.valueType === 'date') {
                    filterStringArray.push(`${filter} ne ${formatDateForFilter(filters[filter].value?.replace(/\\./g, '-'))}`)
                } else {
                    let filterValue: any = parseFloat(parseFloat(filters[filter].value?.replace(',', '.'))?.toFixed(4))
                    const lowEdge = filterValue - 0.0005
                    const highEdge = filterValue + 0.0005
                    filterStringArray.push(`(${filter} le ${lowEdge} or ${filter} ge ${highEdge})`)
                }
            }
        }
    }
    let sortQueryArgsParameters: any = ''
    sortQueryArgsParameters = `${sortField ? sortField : ''}${(sortOrder != 0 && sortOrder != null) ? `${sortOrder == 1 ? ' asc' : ' desc'}` : ''}`
    if (sortField === 'MaintenancePosition') {
        sortQueryArgsParameters = `MaintenancePositionKm${sortOrder == 1 ? ' asc' : ' desc'}` + `,` + `MaintenancePositionM${sortOrder == 1 ? ' asc' : ' desc'}`
    }
    if (sortField === 'MaintenanceEnding') {
        sortQueryArgsParameters = `MaintenanceEndingKm${sortOrder == 1 ? ' asc' : ' desc'}` + `,` + `MaintenanceEndingM${sortOrder == 1 ? ' asc' : ' desc'}`
    }

    return { sortQueryArgsParameters: sortQueryArgsParameters, filterStringArray: filterStringArray, page: page }
}

export function addFilterRule(filterValue: any, fieldName: any, filterOperation: any, filterStringArray: any, columns: any) {
    const col = columns.filter((col: any) => col.dataField === fieldName)[0]
    if (filterValue != null && filterValue != '') {
        if (filterOperation === 'startswith') {
            filterStringArray.push(`startsWith(${filterValue}, '${fieldName}')`)
        }
        if (filterOperation === 'contains') {
            filterStringArray.push(`position('${filterValue}', ${fieldName}) gt 0`)
        }
        if (filterOperation === '=' && tableEnums[fieldName]) {
            filterStringArray.push(`${fieldName} eq ${tableEnums[fieldName][filterValue]}`)
        }
        if (filterOperation === '=' && !tableEnums[fieldName]) {
            if (col.dataType === 'date') {
                filterStringArray.push(`${fieldName} eq ${formatDateForFilter(filterValue?.replace(/\\./g, '-'))}`)
            } else {
                let formattedFilterValue: any = parseFloat(parseFloat(filterValue?.replace(',', '.'))?.toFixed(4))
                const lowEdge = formattedFilterValue - 0.0005
                const highEdge = formattedFilterValue + 0.0005
                filterStringArray.push(`${fieldName} ge ${lowEdge} and ${fieldName} le ${highEdge}`)
            }
        }
        if (filterOperation === '>' && !tableEnums[fieldName]) {
            let formattedFilterValue: any
            if (col.dataType === 'date') {
                formattedFilterValue = formatDateForFilter(filterValue?.replace(/\\./g, '-'))
            } else {
                formattedFilterValue = parseFloat(parseFloat(filterValue?.replace(',', '.'))?.toFixed(4)) + 0.0005
            }
            filterStringArray.push(`${fieldName} gt ${formattedFilterValue}`)
        }
        if (filterOperation === '>=' && !tableEnums[fieldName]) {
            let formattedFilterValue: any
            if (col.dataType === 'date') {
                formattedFilterValue = formatDateForFilter(filterValue?.replace(/\\./g, '-'))
                filterStringArray.push(`${fieldName} ge ${formattedFilterValue}`)
            } else {
                formattedFilterValue = parseFloat(parseFloat(filterValue?.replace(',', '.'))?.toFixed(4)) - 0.0005
                filterStringArray.push(`${fieldName} gt ${formattedFilterValue}`)
            }
        }
        if (filterOperation === '<' && !tableEnums[fieldName]) {
            let formattedFilterValue: any
            if (col.dataType === 'date') {
                formattedFilterValue = formatDateForFilter(filterValue?.replace(/\\./g, '-'))
            } else {
                formattedFilterValue = parseFloat(parseFloat(filterValue?.replace(',', '.'))?.toFixed(4)) - 0.0005
            }
            filterStringArray.push(`${fieldName} lt ${formattedFilterValue}`)
        }
        if (filterOperation === '<=' && !tableEnums[fieldName]) {
            let formattedFilterValue: any
            if (col.dataType === 'date') {
                formattedFilterValue = formatDateForFilter(filterValue?.replace(/\\./g, '-'))
                filterStringArray.push(`${fieldName} le ${formattedFilterValue}`)
            } else {
                formattedFilterValue = parseFloat(parseFloat(filterValue?.replace(',', '.'))?.toFixed(4)) + 0.0005
                filterStringArray.push(`${fieldName} lt ${formattedFilterValue}`)
            }
        }
        if (filterOperation === '<>' && !tableEnums[fieldName]) {
            if (col.dataType === 'date') {
                filterStringArray.push(`${fieldName} ne ${formatDateForFilter(filterValue?.replace(/\\./g, '-'))}`)
            } else {
                let formattedFilterValue: any = parseFloat(parseFloat(filterValue?.replace(',', '.'))?.toFixed(4))
                const lowEdge = formattedFilterValue - 0.0005
                const highEdge = formattedFilterValue + 0.0005
                filterStringArray.push(`(${fieldName} le ${lowEdge} or ${fieldName} ge ${highEdge})`)
            }
        }
    }
}

function addBetweenValuesFilter(filters: any, filterStringArray: any, columns: any) {
    let fieldName = filters[0][0]
    let leftFilterValue = filters[0][2]
    let leftFilterOperation = filters[0][1]
    addFilterRule(leftFilterValue, fieldName, leftFilterOperation, filterStringArray, columns)
    let rightFilterValue = filters[2][2]
    let rightFilterOperation = filters[2][1]
    addFilterRule(rightFilterValue, fieldName, rightFilterOperation, filterStringArray, columns)
}

export function prepareQueryArgsForTableFetchDevExtreme(loadOptions: any, columns: any) {
    let sortField, sortOrder
    if (loadOptions?.sort) {
        sortField = loadOptions?.sort[0]?.selector
        sortOrder = loadOptions?.sort[0]?.desc ? "desc" : "asc"
    }
    let filters: any = loadOptions?.filter
    const filterStringArray: any = []
    if (filters) {
        if ('columnIndex' in filters) {
            if (filters?.selectedFilterOperation === "between") {
                addBetweenValuesFilter(filters, filterStringArray, columns)
            }
            else {
                let fieldName = filters[0]
                let filterOperation = filters[1]
                let filterValue = filters[2]
                addFilterRule(filterValue, fieldName, filterOperation, filterStringArray, columns)
            }
        }
        else {
            filters && filters.map((filter: any) => {
                if (typeof filter === typeof []) {
                    if (typeof filter[0] === typeof []) {
                        filter[0].map((filterDeep: any) => {
                            let fieldName = filterDeep[0]
                            let filterValue = filterDeep?.filterValue ?? filterDeep[2]
                            let filterOperation = filterDeep?.selectedFilterOperation ?? filterDeep[1]
                            if (filterOperation === "between") {
                                addBetweenValuesFilter(filterDeep, filterStringArray, columns)
                            }
                            else {
                                addFilterRule(filterValue, fieldName, filterOperation, filterStringArray, columns)
                            }
                        })
                    }
                    else {
                        let fieldName = filter[0]
                        let filterValue = filter?.filterValue ?? filter[2]
                        let filterOperation = filter?.selectedFilterOperation ?? filter[1]
                        if (filterOperation === "between") {
                            addBetweenValuesFilter(filter, filterStringArray, columns)
                        }
                        else {
                            addFilterRule(filterValue, fieldName, filterOperation, filterStringArray, columns)
                        }
                    }
                }
            })
        }
    }

    let sortQueryArgsParameters: any = ''
    if (sortField && sortOrder) {
        sortQueryArgsParameters = `${sortField} ${sortOrder}`
    }
    if (sortField === 'MaintenancePosition') {
        sortQueryArgsParameters = `MaintenancePositionKm ${sortOrder}` + `,` + `MaintenancePositionM ${sortOrder}`
    }
    if (sortField === 'MaintenanceEnding') {
        sortQueryArgsParameters = `MaintenanceEndingKm ${sortOrder}` + `,` + `MaintenanceEndingM ${sortOrder}`
    }

    return { sortQueryArgsParameters: sortQueryArgsParameters, filterStringArray: filterStringArray }
}

export function getFetchTableUrl(tableValueUrl: string, skip: number, top: any, sortQueryArgsParameters: string, filterStringArray: Array<any>, pathId: any) {
    const currentApiUrl = getItemWebStorage("currentApiUrl")
    let sortParameter = sortQueryArgsParameters ? `&$orderby=${sortQueryArgsParameters}` : ''
    let filterParameter = `&$filter=(${filterStringArray.length > 0 ? filterStringArray.join(' and ') + ' and ' : ''}pathId eq ${pathId})`
    return `${currentApiUrl}/${tableValueUrl}/?$skip=${skip}${top ? `&$top=${top}` : ''}${sortParameter}&$inlinecount=allpages${filterParameter}`
}